// ENTITIES
import { RequestPesquisarRg } from 'pages/iirgd/RgFicDigital/PesquisaRg/Formulario/form';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

export function consultaPesquisaCidadaoKitFamiliaRequest(
	token: string,
	data: RequestPesquisarRg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_REQUEST,
		token,
		payload: {
			data,
		},
	};
}
export function consultaPesquisaCidadaoKitFamiliaSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_SUCCESS,
		payload,
	};
}
export function consultaPesquisaCidadaoKitFamiliaFailure(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_FAILURE,
		payload,
	};
}
export function consultaPesquisaKitFamiliaCidadaoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTA_PESQUISA_CIDADAO_KIT_FAMILIA_CLEAR,
		payload: null,
	};
}
